// extracted by mini-css-extract-plugin
export default {"container":"container-Y_48WdRI","fullWidth":"fullWidth-XmCOkhW1","indicator":"indicator-lxCyHRSH","option":"option-N6kKKL0w","sm":"sm-fZXCv0wa","md":"md-wIYmziCW","lg":"lg-RxGOVwGr"};